import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material//dialog';
import * as globals from 'src/app/globals';
import { Address } from 'src/app/lib/location/classes';

@Component({
  selector: 'app-here-map-dialog',
  templateUrl: './here-map-dialog.component.html',
  styleUrls: ['./here-map-dialog.component.css']
})
export class HereMapDialogComponent implements OnInit {

  hereURI: string;
  street: string;
  zipCode: string;
  city: string;
  country: globals.CountryData;
  countryIcon: string;
  searched: boolean = false;
  zoom: number = 15;
  appId: string = "PRNTikI8E0hulRP2XQCM";
  appCode: string = "H3dOexpc_wMdlWTvHIXxrg";

  _address: Address;
  set address(address: Address){
    this._address = address;
    if(address.addresscountry){
      this.country = globals.countries.find(x => x.name == address.addresscountry);
    }
  }
  get address(): Address {
    return this._address;
  }

  mapHeight: number;
  mapWidth: number;
  timeout: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: HereMapDialogComponentData,
    private _dialogRef: MatDialogRef<HereMapDialogComponent>
  ) {
    if(this._data.address){
      this.address = this._data.address;
      this.validateView();
    }
  }

  close(){
    this._dialogRef.close();
  }

  ngOnInit(): void {

  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.validateView();
  }

  updateSearch(){
    let hereURI = "https://image.maps.api.here.com/mia/1.6/?app_id=" + this.appId + "&app_code=" + this.appCode;
    if(this.country) hereURI += "&co=" + this.country.name;
    if(this.address.addresscity){
      hereURI += "&ci=" + this.address.addresscity;
      this.city = this.address.addresscity;
    } else this.city = null;
    if(this.address.addresszipcode){
      hereURI += "&zi=" + this.address.addresszipcode;
      this.zipCode = this.address.addresszipcode;
    } else this.zipCode = null;
    if(this.address.addressstreet){
      hereURI += "&s=" + this.address.addressstreet;
      this.street = this.address.addressstreet;
    } else this.street = null;
    if(this.address.addresshousenumber){
      hereURI += "&n=" + this.address.addresshousenumber;
      if(this.street) this.street += " " + this.address.addresshousenumber;
    }
    hereURI += "&z=" + this.zoom + "&h=" + this.mapHeight + "&w=" + this.mapWidth;
    this.hereURI = hereURI;
    this.searched = true;
    if(this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  validateView(){
    this.mapHeight = Math.round(window.innerHeight * .8);
    this.mapWidth = Math.round(window.innerWidth * .8);
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.updateSearch(), 50);
  }

  zoomIn(){
    if(this.zoom >= 18) return;
    this.zoom++;
    this.validateView();
  }

  zoomOut(){
    if(this.zoom <= 5) return;
    this.zoom--;
    this.validateView();
  }

}

export class HereMapDialogComponentData {
  address: Address;
}